/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FileUploadDto } from './FileUploadDto';
import {
    FileUploadDtoFromJSON,
    FileUploadDtoFromJSONTyped,
    FileUploadDtoToJSON,
} from './FileUploadDto';

/**
 * 
 * @export
 * @interface FcbFormateurTitreDto
 */
export interface FcbFormateurTitreDto {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    idtitreFormateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    idformateur?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    idtitre?: number;
    /**
     * 
     * @type {string}
     * @memberof FcbFormateurTitreDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurTitreDto
     */
    date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    creationUser?: number;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurTitreDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbFormateurTitreDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurTitreDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {FileUploadDto}
     * @memberof FcbFormateurTitreDto
     */
    fichier?: FileUploadDto;
}

/**
 * Check if a given object implements the FcbFormateurTitreDto interface.
 */
export function instanceOfFcbFormateurTitreDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurTitreDtoFromJSON(json: any): FcbFormateurTitreDto {
    return FcbFormateurTitreDtoFromJSONTyped(json, false);
}

export function FcbFormateurTitreDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurTitreDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtitreFormateur': !exists(json, 'idtitreFormateur') ? undefined : json['idtitreFormateur'],
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'idtitre': !exists(json, 'idtitre') ? undefined : json['idtitre'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'date': !exists(json, 'date') ? undefined : (json['date'] === null ? null : new Date(json['date'])),
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fichier': !exists(json, 'fichier') ? undefined : FileUploadDtoFromJSON(json['fichier']),
    };
}

export function FcbFormateurTitreDtoToJSON(value?: FcbFormateurTitreDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtitreFormateur': value.idtitreFormateur,
        'idformateur': value.idformateur,
        'idtitre': value.idtitre,
        'libelle': value.libelle,
        'date': value.date === undefined ? undefined : (value.date === null ? null : value.date.toISOString()),
        'creationUser': value.creationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'idfichier': value.idfichier,
        'fichier': FileUploadDtoToJSON(value.fichier),
    };
}

